/**
 * HealthVitals.tsx
 *
 *
 * Description:
 * This component renders the health vitals section of a user’s health profile.
 * It includes a page header, health profile tabs, and User vitals information.
 * The component uses data from the Redux store to get the user's details.
 *
 * Date: 22-08-2024
 */

import React from "react";
import HealthProfileTabs from "src/Components/Customer/HealthProfileTabs";
import PageHeader from "src/Components/Customer/PageHeader";
import UserVitals from "src/Components/GlobalComponents/HealthProfiles/UserVitals";

const HealthVitals: React.FC = () => {
  return (
    <>
      {/* Render the page header with the title "Health Profile" */}
      <PageHeader title="Health Profile" />
      <div
        style={{
          minHeight: `calc(${
            document.getElementById("customer-sidebar-id")?.offsetHeight
          }px - 1rem - ${document.getElementById("headerH")?.offsetHeight}px)`,
        }}
        className="parent-box parent-box-height"
      >
        {/* Render tabs for navigating the health profile sections */}
        <HealthProfileTabs />
        {/* Render the user vitals information component, passing the user ID */}
        <UserVitals />
      </div>
    </>
  );
};

export default HealthVitals;
